/*
  Docs for Number Format options
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
*/

var i18n = {
  locales: ["pt-BR"],
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }
    }
  },
  messages: {
    phone : {
      type : {
        work: "comercial",
        mobile: "celular",
        fax: "fax",
        ramal: "ramal",
        radio: "radio"
      }
    },
    birthday : {
      relative :
        "{days, plural,\
          =0 {<span class='hover-secondary-text-highlight'>hoje</span>}\
          =1 {falta}\
          other {faltam}\
        } {days, plural,\
          =0 {}\
          =1 {<span class='hover-secondary-text-highlight'>#</span> dia}\
          other {<span class='hover-secondary-text-highlight'>#</span> dias}\
        }"
    },
    deal : {
      status: {
        won: "Ganho",
        progress: "Andamento",
        lost: "Perdido"
      },
      undefined_period: "Período indefinido",
      end_period : {
        delayed :
          "{deal_status, select, \
            1 {Atrasado }\
            2 {Ganho há }\
            3 {Perdido há }\
          }{days, plural,\
            =1 {<span class='hover-text-highlight'>#</span> dia}\
            other {<span class='hover-text-highlight'>#</span> dias}\
          }",
        on_time:
          "{deal_status, select, \
            1 {{days, plural,\
              =0 {Conclusão <span class='hover-text-highlight'>hoje</span>}\
              other {Conclusão em <span class='hover-text-highlight'>#</span>}\
            }}\
            2 {{days, plural,\
              =0 {Ganho <span class='hover-text-highlight'>hoje</span>}\
              other {Conclusão em <span class='hover-text-highlight'>#</span>}\
            }}\
            3 {{days, plural,\
              =0 {Perdido <span class='hover-text-highlight'>hoje</span>}\
              other {Conclusão em <span class='hover-text-highlight'>#</span>}\
            }}\
          } {days, plural,\
            =0 {}\
            =1 {dia}\
            other {dias}\
          }"
      },
      total_results : {
        text :
          "{deals, plural,\
            =0 {Nenhum negócio}\
            =1 {# negócio}\
            other {# negócios}\
          }"
      },
      empty_history: {
        title: "Nenhuma atividade registrada",
        subtitle: "Que tal agendar uma ligação ou uma visita para evoluir este negócio?"
      }
    },
    view_more: "Ver mais",
    view_less: "Ver menos",
    listing: {
      first_use: {
        title :"{env, select, \
          organization {É aqui que seus futuros clientes ficam}\
          person {É aqui que seus futuros clientes e contatos ficam}\
          deal {Todas as suas oportunidades de negócios ficarão aqui}\
        }",
        subtitle :"{env, select, \
          organization {Adicione e gerencie seus clientes e boas vendas!}\
          person {Adicione e gerencie seus contatos e boas vendas!}\
          deal {Acompanhe e não perca nenhuma oportunidade de venda!}\
        }",
      }
    },
    list_empty : {
      no_query_filter:
        "A busca {filtersCount, plural,\
          =0 {}\
          =1 {com o filtro <span class='listing-emptyListMessage-highlight'>{filters}</span> }\
          other {com os filtros <span class='listing-emptyListMessage-highlight'>{filters}</span> }\
        }não trouxe nenhum resultado",
      with_query_filter :
        "A busca {env, select, \
          organization {pela empresa <span class='listing-emptyListMessage-highlight'>{q}</span> }\
          person {pela pessoa <span class='listing-emptyListMessage-highlight'>{q}</span> }\
          deal {pelo negócio <span class='listing-emptyListMessage-highlight'>{q}</span> }\
        }{filtersCount, plural,\
          =0 {}\
          =1 {com o filtro <span class='listing-emptyListMessage-highlight'>{filters}</span> }\
          other {com os filtros <span class='listing-emptyListMessage-highlight'>{filters}</span> }\
        }não trouxe nenhum resultado"
    },
    entity: {
      empty_history: {
        title: "Nenhuma atividade registrada",
        subtitle: "Que tal agendar uma ligação ou uma visita a este contato?"
      }
    },
    activities: {
      empty_list : {
        title: "Nenhuma atividade registrada",
        subtitle: "Que tal agendar uma ligação ou uma visita a um cliente? :)"
      },
      request_error_message: {
        client_side: "Ops, parece que você não possui conexão com a internet :(",
        server_side: {
          short: "Ops, não foi possível listar as atividades :(",
          full: "<div><span>Ops, não foi possível listar as atividades :(</span><br/><div class='ls-0 fs-20 m-10'>Se o problema persistir entre em contato com o nosso suporte através do <a href='#' onClick='Intercom(\"showNewMessage\");'>nosso chat</a> ou pelo <a href='mailto:contato@agendor.com.br'>contato@agendor.com.br</a>.",
        },
        generic: "Ops, algo deu errado ao tentar listar as atividades :("
      }
    },
    tasks: {
      empty_list: {
        pending:
          "Nenhuma {metricsCount, plural,\
            =0 { tarefa }\
            =1 {tarefa do tipo <span class='fw-bold'>{metricsNames}</span>}\
            other {tarefa do tipo <span class='fw-bold'>{metricsNames}</span>}\
          } pendente {hasUser, select, \
            true {para <span class='fw-bold'>{username}</span>}\
            false {}\
          } {dateRange, select, \
            TODAY { para <span class='fw-bold'>hoje</span>}\
            WEEK { para <span class='fw-bold'>esta semana</span>}\
            CUSTOM { para o período <span class='fw-bold'>{dtInicial} à {dtFinal}</span>}\
            other {}\
          }",
        done:
          "Nenhuma {metricsCount, plural,\
            =0 { tarefa }\
            =1 {tarefa do tipo <span class='fw-bold'>{metricsNames}</span>}\
            other {tarefa do tipo <span class='fw-bold'>{metricsNames}</span>}\
          } finalizada {hasUser, select, \
            true {por <span class='fw-bold'>{username}</span>}\
            false {}\
          } {dateRange, select, \
            TODAY { <span class='fw-bold'>hoje</span>}\
            WEEK { <span class='fw-bold'>esta semana</span>}\
            CUSTOM { entre <span class='fw-bold'>{dtInicial} e {dtFinal}</span>}\
            other {}\
          }",
        subtitle: "Que tal agendar uma ligação ou uma visita a um cliente? :)"
      }
    },
    shared_components: {
      dropdown: {
        loading: "Carregando..."
      },
      user_selector: {
        loading: "Carregando...",
        search: "Procurar",
        no_user: "Nenhum usuário encontrado"
      },
      button: {
        confirm: "Confirmar"
      }
    },
    integration: {
      google_calendar: {
        title: "Integração Agendor ↔ Google Agenda",
        active_integration: "Quando a integração com o Google Agenda estiver ativa:",
        sync_activities: "Uma nova tarefa no Agendor será enviada para o Google Agenda. ",
        type_configuration: "Configure os tipos de atividade (visita, ligação, etc) que deseja que sejam enviados (em breve). ",
        custom_notification: "Personalize as notificações de cada tipo de atividade (em breve). ",
      },
      tags: {
        new: "Novidade!",
        beta: "Beta!"
      }
    },
    pricing: {
      header: {
        title: "**Plano {planName}**",
        subtitle:
        " **R$ {priceValue}** {priceValue, select, \
          0 {para sempre} \
          other {mensais por usuário} \
        }",
      },
      users_capacity: {
        pro: "Quantos **usuários** sua equipe precisa?",
        free: {
          maximum: "Máximo de",
          users: "usuários"
        }
      },
      price: {
        value: "R$ {priceValue}",
        month: "/ mês",
        discount_expiring: "(Desconto válido até {expiringDate})"
      },
      features: {
         limited_entries: "Com limite de cadastros",
         limited_entries_explained: "Máximo de 1.000 empresas, 1.000 pessoas e 150 negócios cadastrados.",
         unlimited_entries: "**Sem limite** de cadastros",
         unlimited_entries_explained: "Sem limite de empresas, pessoas e negócios cadastrados.",
         limited_storage: "Limite de **2GB** de armazenamento",
         unlimited_storage: "**Sem limite** de armazenamento",
         storage_explained: "Armazene propostas, orçamentos, imagens ou qualquer outro tipo de documento.",
         integrations_and_api: "Integrações e acesso a API",
         integrations_and_api_free_explained: "Integração nativa com RD Station e acesso à nossa API, para integrar com seu site, sistema financeiro, estoque ou qualquer outro sistema.",
         integrations_and_api_pro_explained: "Integrações nativas com Google Agenda e RD Station, e acesso à nossa API, para integrar com seu site, sistema financeiro, estoque ou qualquer outro sistema.",
         automatic_email: "Gravação de e-mails **automática**",
         automatic_email_explained: "Copie o email do seu Agendor em conversas com seus clientes e deixe que o Agendor organize seus históricos de negociação.",
         mobile_sync: "Apps Android e iOS com **acesso offline**",
         mobile_sync_explained: "Consulte suas vendas e clientes de onde estiver, mesmo sem conexão com a internet.",
         customer_success_free: "Orientação por chat e e-mail",
         customer_success_pro: "Orientação por chat, e-mail e **telefone**",
         privacy_contol: "**Controle** de privacidade",
         privacy_contol_explained: "Evite que um vendedor veja a carteira de clientes de outro vendedor.",
         custom_features: "**Personalizações**",
         custom_features_explained: "Configure o Agendor para sua empresa através da personalização de Etapas de venda, Categorias de contato, Motivos de Perda de negócios, Origens de cliente e Setores.",
         integration_rd: "Integração com **RD Station**",
         integration_rd_explained: "Integração nativa com RD Station.",
         integration_google_agendas: "Integração com **Google Agenda**",
         integration_google_agendas_explained: "Integração nativa com Google Agenda.",
         api_access: "Acesso à **API** para integrações",
         api_access_explained: "Acesso à nossa API, para integrar com seu site, sistema financeiro, estoque ou qualquer outro sistema.",
         team_level_access: "**Níveis de acesso** de equipes",
         team_level_access_explained: "O Controle de Privacidade por Equipes permite que os líderes de cada equipe tenham acesso aos clientes e negócios de seus liderados e evita o acesso aos dados de outras equipes. Ótimo para formação de equipes de vendas com gestores e vendedores.",
         agendor_method: "**Método Agendor**",
         agendor_method_explained: "Modelo ágil e eficiente de treinamento para implantação do Agendor em sua área comercial. Ajudamos a configurar sua conta e implantar o melhor processo de vendas com o Agendor para seu negócio. Tudo isso através de videoconferências, telefonemas, chats e e-mails.",
         monthly_report: "**Sumário de vendas** mensal",
         monthly_report_explained: "Relatório mensal enviado automaticamente por email com os principais indicadores de vendas. Tempo médio do ciclo de vendas, taxas de conversão do funil, ticket-médio, maiores motivos de perdas de negócios e melhores origens de clientes. Tudo que você precisa para aprimorar seu processo de vendas.",
         zapier_integration: "Integração com **+1.000** softwares",
         zapier_integration_explained: "Integração através do Zapier, uma plataforma de integração de diversas ferramentas (ex: Proposify, Trello, Google Planilhas, etc)",
         whatsapp_integration: "Integração com o **WhatsApp**",
         whatsapp_integration_explained: "Inicie conversas do Agendor com WhatsApp em apenas um clique."
      },
      buttons: {
        current_plan: "Você está neste plano",
        start_free: "Comece a usar grátis",
        try_free: "Experimente por {days} dias grátis",
        buy_now: "ou contratar agora",
        renew_plan: "Simular renovação",
        raise_plan: "Simular aumento de plano",
        downgrade_plan: "Simular redução de plano",
        subscribe: "Simular assinatura",
        raise_plan_freely: "Aumentar plano gratuitamente",
        downgrade_plan_freely: "Reduzir plano gratuitamente",
        plan_downgrade_request: "Solicitar redução de plano"
      },
      warning: {
        user_overflow: "Desative {users} {users, select, \
          1 {usuário}\
          other {usuários}\
        } para poder reduzir seu plano",
        admin_only: "Disponível somente para Administradores desta conta",
        wait_expire: "Aguarde sua conta expirar para reduzir seu plano"
      }
    },
    card: {
      global: {
        search: "Procurar",
        cancel: "cancelar",
        save: "Salvar"
      },
      products: {
        title: "Produtos ou serviços relacionados",
        empty: "nenhum produto/serviço relacionado"
      }
    },
    prompt: {
      account_privacy_change: {
        title: "Confirme as ações que realizaremos em sua conta",
        closed_to_open: "Confirmo que todas as empresas, pessoas e negócios já cadastrados terão a privacidade desativada e serão visíveis a todos da conta",
        open_to_closed: "Confirmo que todas as empresas, pessoas e negócios já cadastrados terão a privacidade ativada e serão visíveis apenas aos seus usuários criadores, responsáveis, aos líderes dos responsáveis e aos administradores da conta"
      },
      remove_team: {
        title: "Tem certeza que deseja remover a equipe {teamName}?",
        text: "Ao remover uma equipe , os líderes dela perderão a visibilidade de todo o histórico e informações da carteira de cliente dos membros. Os membros e os usuários do grupo administradores continuarão com acesso.",
        checkbox_item: "Remover equipe e retirar visibilidade dos líderes sobre o histórico e carteira de clientes dos membros."
      },
    },
    team: {
      found: " {teamsLength, select, \
        1 {equipe encontrada} \
        other {equipes encontradas} \
      }",
      few_active_users: "Você possui apenas {activeUserCount, select, \
        1 {1 usuário} \
        other {{activeUserCount} usuários} \
      } em sua conta. Para criar equipes, você precisa convidar pelo menos {minUserCount, select, \
        1 {1 usuário} \
        other {{minUserCount} usuários} \
      }.",
      no_team_registered: {
        title: "Nenhuma Equipe registrada",
        subtitle: "Crie equipes para definir quais gestores (**líderes**) podem visualizar a carteira de clientes de quais vendedores (**membros**). Equipes também permitem que você defina a hierarquia da sua empresa."
      },
      open_account_warning: {
        title: "Sua conta está com a privacidade aberta.",
        text: "Mesmo após criar equipes, cada vendedor continuará visualizando os clientes um do outro. Para limitar a visibilidade das carteiras de clientes, você pode alterar a configuração de privacidade para fechada."
      }
    }
  }
};

module.exports = i18n;



// WEBPACK FOOTER //
// ./app/util/i18n/i18n.js